import { Component, input } from '@angular/core';
import { CurrencyPipe } from '@shared/pipes/currency.pipe';
import { PercentagePipe } from '@shared/pipes/percentage.pipe';

@Component({
  selector: 'app-original-price',
  standalone: true,
  imports: [CurrencyPipe, PercentagePipe],
  templateUrl: './original-price.component.html',
  styleUrl: './original-price.component.scss'
})
export class OriginalPriceComponent {
  originalprice = input<number>();
  discount = input<number>();
}
